import React from "react";

export default function SocialButton(props) {
    let { link, icon, backgroundColor, color, onClickEvent } = props;

    if(!link) {
        return (
            <div onClick={() => onClickEvent()} class="share-social-button" style={{color: color ? color : 'white', backgroundColor}}>
                <i className={icon}></i>
            </div>
        )
    }
    return (
        <a href={link} target="_blank" class="share-social-button" style={{color: color ? color : 'white', backgroundColor}}>
            <i className={icon}></i>
        </a>
    )
}